<template>
  <div>
    <header
      :class="
        header.Classes +
        ' h-12 content-center px-3 items-center grid grid-cols-auto-1-auto gap-2'
      "
    >
      <!-- LEFT -->
      <div class="flex row-wrap items-center">
        <!-- Backbutton -->
        <div class="mr-4" v-if="header.BackButton">
          <wd-button transparent @input="back">
            <icon name="Back" size="1.5rem" />
          </wd-button>
        </div>
        <!-- Custom left -->
        <div class="flex row-wrap items-center" v-if="elementsLeft">
          <wd-header-element
            class="mr-2 last:mr-0"
            v-for="(element, index) in elementsLeft"
            :key="index"
            :element="element"
          />
        </div>
        <!-- Default left -->
        <div
          class="flex-wrap flex items-center"
          v-else-if="!header.BackButton && !header.Clear"
        >
          <icon
            class="mr-2"
            name="WaldigLogo"
            size="1.8rem"
            :settings="{ circle: true }"
          />
          <div class="grid items-center">
            <div class="uppercase tracking-widest">Stupsi</div>
          </div>
        </div>
      </div>

      <!-- CENTER -->
      <div>
        <!-- Custom center -->
        <div class="flex row-wrap items-center" v-if="elementsCenter">
          <wd-header-element
            class="mr-2 last:mr-0"
            v-for="(element, index) in elementsCenter"
            :key="index"
            :element="element"
          />
        </div>
      </div>

      <!-- RIGHT -->
      <div class="flex row-wrap items-center">
        <!-- Custom right -->
        <div class="flex row-wrap items-center" v-if="elementsRight">
          <wd-header-element
            class="mr-2 last:mr-0"
            v-for="(element, index) in elementsRight"
            :key="index"
            :element="element"
          />
        </div>
        <!-- Default right -->
        <div class="block relative flex items-center">
          <div class="ml-1" v-if="header.Help">
            <wd-button transparent @input="header.Help()">
              <icon name="Help" size="1.3em" />
            </wd-button>
          </div>
          <button
            class="button-transparent button-no-spacing ml-1"
            @click="toggleDropdown"
            v-if="!header.Clear"
          >
            <div class="w-8 h-8">
              <avatar :avatar="avatar" />
            </div>
          </button>
          <drop-down @close="toggleDropdown" v-if="dropdownVisible">
            <div class="cursor-pointer stack">
              <div class="text-right">
                <wd-button
                  class="normal-case text-right text-primary-700"
                  transparent
                  @input="openInfos"
                  >{{ $t("general.about_stupsi") }}</wd-button
                >
              </div>
              <div class="text-right">
                <wd-button
                  class="normal-case text-right"
                  transparent
                  @input="openMyProfile"
                  >{{ $t("users.profile") }}</wd-button
                >
              </div>
              <div class="text-right">
                <wd-button
                  class="normal-case text-right"
                  transparent
                  @input="openSettings"
                  >{{ $t("users.settings.general_settings") }}</wd-button
                >
              </div>
              <div class="text-right">
                <wd-button
                  class="normal-case text-right"
                  transparent
                  @input="logout"
                  >{{ capitalize($t("login.logout_verb")) }}</wd-button
                >
              </div>
            </div>
          </drop-down>
        </div>
      </div>
    </header>
    <div
      v-if="
        header.Tabs && header.Tabs.elements && header.Tabs.elements.length > 0
      "
    >
      <tabs :css="header.Bg">
        <tab
          v-for="(tab, index) in header.Tabs.elements"
          :key="index"
          :bright="tab.bright"
          @input="updateTab(index, tab.action)"
          :active="index === activeTab"
          >{{ tab.title }}</tab
        >
      </tabs>
    </div>
  </div>
</template>

<script>
const WdHeaderElement = require("@/modules/header/components/WdHeaderElement.vue")
  .default;
const Avatar = require("@/modules/avatars/components/Avatar.vue").default;
const DropDown = require("@/modules/core/components/DropDown.vue").default;
const Tab = require("@/modules/core/components/Tab.vue").default;
const Tabs = require("@/modules/core/components/Tabs.vue").default;

export default {
  name: "WdHeader",
  data() {
    return {
      dropdownVisible: false,
    };
  },
  props: {},
  components: {
    WdHeaderElement,
    Avatar,
    DropDown,
    Tab,
    Tabs,
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    toggleDropdown(Bool) {
      this.dropdownVisible =
        typeof Bool === "boolean" ? Bool : !this.dropdownVisible;
    },
    openMyProfile() {
      this.$router.push("/profile");
      this.toggleDropdown(false);
    },
    openSettings() {
      this.$router.push("/profile-edit");
      this.toggleDropdown(false);
    },
    openInfos() {
      this.$router.push("/infos");
      this.toggleDropdown(false);
    },
    updateTab(index, action) {
      this.$store.dispatch("header/updateTab", index);
      if (action !== undefined) {
        action();
      }
    },
  },
  computed: {
    header() {
      return this.$store.getters["header/header"];
    },
    elementsLeft() {
      return this.header.getElements("left").length > 0
        ? this.header.getElements("left")
        : false;
    },
    elementsCenter() {
      return this.header.getElements("center").length > 0
        ? this.header.getElements("center")
        : false;
    },
    elementsRight() {
      return this.header.getElements("right").length > 0
        ? this.header.getElements("right")
        : false;
    },
    activeTab() {
      return this.$store.getters["header/activeTab"];
    },
    avatar() {
      return this.$store.getters["useravatar/avatar"];
    },
  },
  created() {},
};
</script>
